/**
 * Application configuration constants
 * Centralized configuration for motion detection and UI behavior
 */

/** Duration for word card animations in milliseconds */
export const ANIMATION_DURATION_MS = 600;

/** Acceleration threshold for shake detection (higher = less sensitive) */
export const SHAKE_THRESHOLD = 15;

/** Minimum time between shake detections to prevent rapid repeated triggers */
export const SHAKE_TIMEOUT_MS = 1000;

/** React Query cache time in milliseconds (5 minutes) */
export const QUERY_CACHE_TIME_MS = 300000;

/** Application metadata */
export const APP_CONFIG = {
  name: 'Shake To Learn',
  description: 'Learn words by shaking your phone',
  version: '1.0.0',
} as const;

